/** @format */

import React from "react";
import ReactDOM from "react-dom/client";
import "./assets/css/output.css";
import App from "./App/App";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<App />);
